<template>
    <div v-if="showActionButtons" class="ufo-sepa--buttons">

        <div v-if="settings.showInfoAboveCtas"
             class="info-above-cta"
             @mouseleave="hideColorOverrideExplanation()">
            <p class="e-ui-b2-regular">
                {{message}}
                <Cta v-if="hasInfoLink"
                     type="link"
                     dark-scheme
                     @click="navigateToInfoLink()"
                >
                    {{ settings.infoAboveCtasLinkText }}
                    <Icon icon-name="arrow-out" :width="14" :height="14" />
                </Cta>
                <Cta v-else-if="showWhyToggle"
                     type="link"
                     dark-scheme
                     @click="showColorOverrideExplanation()"
                     @mouseover="showColorOverrideExplanation()"
                     @focus="showColorOverrideExplanation()"
                     @blur="hideColorOverrideExplanation()"
                >
                    Why?
                </Cta>
            </p>
        </div>
        <!-- secondary cta button // cancel button -->
        <Cta :type="'secondary'"
             dark-scheme
             @click="secondaryAction()"
        >
            Cancel
        </Cta>

        <!-- primary cta button // save/update button -->
        <Cta :disabled="!settings.allowSave"
             dark-scheme
             @click="primaryAction()"
        >
            {{settings.saveButton}}
        </Cta>

    </div>
</template>

<script>
    import Cta from "../../components/CtaButton.vue";
    import Icon from "../../Icon.vue";

    export default {
        name: 'panel-footer',
        components: {Cta, Icon},
        data() {
            return {
                showSecondaryText: false,
            }
        },
        computed: {
            settings() {
                return this.$store.state.sidePanelSettings;
            },
            showActionButtons() {
                return !this.settings.hideActionButtons
            },
            message() {
                if (this.settings.infoAboveCtasMessage) return this.settings.infoAboveCtasMessage;
                return this.showSecondaryText
                    ? 'Your colors on custom backgrounds auto-adjust for clear readability.'
                    : 'Your colors only update on sections without a custom background.';
            },
            hasInfoLink() {
                return !!this.settings.infoAboveCtasLinkUrl;
            },
            showWhyToggle() {
                return !this.showSecondaryText && !this.settings.infoAboveCtasMessage;
            }
        },
        methods: {
            // emit events to parent
            primaryAction() {
                this.$store.state.sidePanelSettings.activeModal = null;
                this.$emit('primaryAction');
            },
            secondaryAction() {
                this.$store.state.sidePanelSettings.activeModal = null;
                this.$emit('secondaryAction');
            },
            navigateToInfoLink() {
                this.$router.push(this.settings.infoAboveCtasLinkUrl);
            },
            showColorOverrideExplanation() {
                this.showSecondaryText = true;
            },
            hideColorOverrideExplanation() {
                this.showSecondaryText = false;
            },
            back() {
                this.$emit('back');
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ufo-sepa--buttons {
        --bgColor: var(--asphalt10);
        border-top: 1px solid var(--asphalt80);

        padding: 32px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 16px;
    }
    .info-above-cta {
        width: 100%;
        grid-column: 1 / span 2;

        display: flex;
        padding: 16px;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;

        border-radius: 4px;
        background: var(--asphalt90);
        position: relative;

        p {
            color: var(--asphalt40);
        }

        .ufo-cta--link :deep(.icon-container) {
            gap: 4px;
        }

        &:before {
            content: '';
            width: 4px;
            height: 100%;
            border-radius: 4px 0 0 4px;

            position: absolute;
            top: 0;
            left: 0;

            background: var(--asphalt40);

        }
    }

    .large-tooltip-container {
        position: fixed;
        left: 377px;
        right: unset;
        bottom: 82px;
        top: unset;
    }
</style>